import { render } from "./TitulacionsView.vue?vue&type=template&id=5d08a1bb"
import script from "./TitulacionsView.vue?vue&type=script&lang=js"
export * from "./TitulacionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__